exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print\r\n{    \r\n  .no-print\r\n  {\r\n      display: none !important;\r\n  }\r\n}\r\n\r\n\r\n.btn {\r\n   padding: 7px 12px;\r\n}\r\n\r\n\r\n.table {\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n@media screen and (min-width: 768px){\r\n  .jumbotron {\r\n\t    padding: 110px 0;\r\n\t}\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px){\r\n .jumbotron {\r\n\t    padding: 85px 0;\r\n\t}\r\n}\r\n\r\n\r\n@media screen and (max-width: 768px){\r\n  #desktop-view{\r\n    display: none;\r\n  }\r\n}\r\n\r\n\r\n@media screen and (min-width: 768px){\r\n  #mobile-view{\r\n    display: none;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/orders/order-detail/order-detail.component.css
// module id = ../../../../../src/app/components/orders/order-detail/order-detail.component.css
// module chunks = main